import { Box } from '@mui/material';
import { getPurchaseOrderDetails } from 'lib/api/publicMarket';
import TableWithPagination, {
  Header,
} from 'lib/designSystem/TableWithPagination';
import { errorHandler } from 'lib/functions/errors';
import { PurchaseOrder } from 'lib/types/models';
import { Pagination } from 'lib/types/shared';
import React from 'react';
import { useDispatch } from 'react-redux';
import { showPurchaseOrderModal } from 'services/redux/purchaseOrderModalSlice';

export interface PurchaseOrdersProps {
  loading: boolean;
  fetchData: (params?: { page: number; pageSize: number }) => Promise<{
    data: PurchaseOrder[];
    pagination: Pagination;
  } | void>;
  data: PurchaseOrder[];
  setData: (data: PurchaseOrder[]) => void;
  pagination: Pagination;
  setPagination: (pagination: Pagination) => void;
}

const PurchaseOrders: React.FC<PurchaseOrdersProps> = ({
  loading,
  fetchData,
  data,
  setData,
  pagination,
  setPagination,
}) => {
  const dispatch = useDispatch();

  const headers: Header[] = [
    {
      label: 'Código',
      key: 'externalCode',
      customComponent: (value: string) => <Box sx={{ py: 1 }}>{value}</Box>,
    },
    { label: 'Nombre', key: 'name' },
    { label: 'Tipo', key: 'type' },
    { label: 'Estado', key: 'status' },
    { label: 'Mandante', key: 'buyerId' },
    { label: 'Proveedor', key: 'supplierId' },
    { label: 'Fecha Creación', key: 'creationDate', type: 'date' },
    { label: 'Monto Total', key: 'total', type: 'money' },
  ];

  const handleRowClick = async (rowId: string) => {
    try {
      if (!rowId) throw new Error('Purchase Order ID is required');
      const details = await getPurchaseOrderDetails(dispatch, rowId);
      if (details) dispatch(showPurchaseOrderModal(details));
    } catch (error) {
      errorHandler(dispatch, error);
    }
  };

  return (
    <Box sx={{ py: 2 }}>
      <TableWithPagination
        data={data}
        setData={setData}
        dataHeaders={headers}
        loading={loading}
        handleClickRow={handleRowClick}
        pagination={pagination}
        setPagination={setPagination}
        searchData={fetchData}
        exportToFile="xlsx"
      />
    </Box>
  );
};

export default PurchaseOrders;
